export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()
  const accessKey = runtimeConfig.public.unsplashAccessKey
  const baseUrl = 'https://api.unsplash.com'

  const headers = {
    Authorization: `Client-ID ${accessKey}`,
  }

  return {
    provide: {
      unsplash: {
        async getPhoto(photoId: string) {
          try {
            const res = await fetch(`${baseUrl}/photos/${photoId}`, { headers })
            if (!res.ok) return null
            return await res.json()
          } catch (e) {
            console.error('Unsplash getPhoto error:', e)
            return null
          }
        },
        async getPhotos(username: string, page: number = 1, perPage: number = 25) {
          try {
            const res = await fetch(
              `${baseUrl}/users/${username}/photos?page=${page}&per_page=${perPage}`,
              { headers }
            )
            if (!res.ok) return null
            const photos = await res.json()
            return { results: photos, total: photos.length }
          } catch (e) {
            console.error('Unsplash getPhotos error:', e)
            return null
          }
        },
      },
    },
  }
})
